import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { getSurveyContext, submitSurvey } from "../api/clientSurveys";
import SurveyForm from "../components/surveys/SurveyForm";

export default function PublicSurvey() {
  const { token } = useParams();
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    if (!token) return;
    setLoading(true);
    setError("");
    getSurveyContext(token)
      .then((data) => {
        if (!mounted) return;
        setContext(data);
      })
      .catch((err) => {
        if (!mounted) return;
        setError(err?.response?.data?.detail || "Unable to load survey.");
      })
      .finally(() => {
        if (!mounted) return;
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, [token]);

  const headerTitle = useMemo(
    () => context?.survey_config?.title || "Rate Your Visit",
    [context]
  );
  const headerSubtitle = useMemo(
    () => context?.survey_config?.subtitle || "",
    [context]
  );

  const handleSubmit = async (payload) => {
    if (!token) return null;
    return submitSurvey(token, payload);
  };

  return (
    <div className="px-4 py-6">
      <div className="mx-auto w-full max-w-[900px] text-sm md:text-base">
        <div className="rounded-3xl border border-slate-200 bg-white shadow-2xl overflow-hidden">
          <div className="bg-rose-500 px-6 py-4">
            <h1 className="text-xl md:text-2xl font-semibold text-white">
              {headerTitle}
            </h1>
            {headerSubtitle && (
              <div className="text-sm text-rose-50 mt-1">
                {headerSubtitle}
              </div>
            )}
          </div>
          <div className="px-6 py-6 space-y-6">
            {loading && (
              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-600">
                Loading survey...
              </div>
            )}
            {error && (
              <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-rose-700">
                {error}
              </div>
            )}

            {!loading && !error && context && (
              <SurveyForm
                context={context}
                onSubmit={handleSubmit}
                resetKey={token}
                submitLabel="Submit feedback"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
